export enum HallChalkBoardView {
  'vessel-forecast' = 'Vessel Forecast',
  'work-info-by-category' = 'Work Information',
  'coastwise-work-info' = 'Coastwise Work Information'
}